"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _immer = _interopRequireDefault(require("immer"));

var _component = require("../component");

var _shallowEqual = _interopRequireDefault(require("../utils/shallowEqual"));

var _utils = _interopRequireDefault(require("./utils"));

var _Picker = _interopRequireDefault(require("./Picker"));

var _styles = require("../styles");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

var Range =
/*#__PURE__*/
function (_PureComponent) {
  _inheritsLoose(Range, _PureComponent);

  function Range(props) {
    var _this;

    _this = _PureComponent.call(this, props) || this;
    _this.state = {
      hover: undefined,
      rangeDate: props.value
    };
    _this.pickers = [];
    _this.handleFirstChange = _this.handleChange.bind(_assertThisInitialized(_assertThisInitialized(_this)), 0);
    _this.handleSecondChange = _this.handleChange.bind(_assertThisInitialized(_assertThisInitialized(_this)), 1);
    _this.handleDayHover = _this.handleDayHover.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.bindFirstPicker = _this.bindPicker.bind(_assertThisInitialized(_assertThisInitialized(_this)), 0);
    _this.bindSecondPicker = _this.bindPicker.bind(_assertThisInitialized(_assertThisInitialized(_this)), 1);
    _this.handleDisabledStart = _this.handleDisabled.bind(_assertThisInitialized(_assertThisInitialized(_this)), 'start');
    _this.handleDisabledEnd = _this.handleDisabled.bind(_assertThisInitialized(_assertThisInitialized(_this)), 'end');
    _this.fillTime = _this.fillTime.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    return _this;
  }

  var _proto = Range.prototype;

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    var rangeDate = this.state.rangeDate;

    if (rangeDate.length !== 1 && !(0, _shallowEqual.default)(prevProps.value, this.props.value) && !(0, _shallowEqual.default)(this.state.rangeDate, this.props.value)) {
      // eslint-disable-next-line
      this.setState({
        rangeDate: this.props.value
      });
    }
  };

  _proto.bindPicker = function bindPicker(index, el) {
    this.pickers[index] = el;
  };

  _proto.resetRange = function resetRange(rangeDate) {
    this.setState({
      rangeDate: rangeDate,
      hover: undefined
    });
  };

  _proto.handleDayHover = function handleDayHover(date) {
    if (this.state.rangeDate.length === 1) {
      _utils.default.cloneTime(date, this.props.value[1], this.props.format);

      this.setState({
        hover: date
      });
    }
  };

  _proto.handleChange = function handleChange(index, date, change, end, mode) {
    var _this2 = this;

    var _this$props = this.props,
        type = _this$props.type,
        range = _this$props.range;

    if (!change) {
      var current = (0, _immer.default)(this.props.current, function (draft) {
        draft[index] = date;
      });
      this.props.onChange(current);
      return;
    }

    if (mode === 'time') {
      var endChangedDate;
      this.setState((0, _immer.default)(function (draft) {
        draft.rangeDate[index] = date;
        var _draft$rangeDate = draft.rangeDate,
            s = _draft$rangeDate[0],
            e = _draft$rangeDate[1];
        if (index !== 0) return;

        if (range && _utils.default.compareAsc(s, e) === 1) {
          endChangedDate = date;
          draft.rangeDate[1] = endChangedDate;
        }

        if (typeof range === 'number' && _utils.default.compareAsc(s, _utils.default.addSeconds(e, -range)) < 0) {
          endChangedDate = _utils.default.addSeconds(s, range);
          draft.rangeDate[1] = endChangedDate;
        }
      }), function () {
        var current = (0, _immer.default)(_this2.props.value, function (draft) {
          draft[index] = date;
          if (endChangedDate) draft[1] = endChangedDate;
        });

        _this2.props.onChange(current, true);
      });
      return;
    }

    if (type === 'month') {
      // eslint-disable-next-line
      var rangeDate = [].concat(this.state.rangeDate);
      rangeDate[index] = date;

      if (rangeDate.some(function (v) {
        return !_utils.default.isInvalid(v);
      })) {
        rangeDate.sort(function (a, b) {
          return a.getTime() - b.getTime();
        });
      }

      this.setState({
        rangeDate: rangeDate
      });
      this.props.onChange(rangeDate, true);
      return;
    }

    _utils.default.cloneTime(date, this.props.value[index]);

    if (this.state.rangeDate.length !== 1) {
      this.setState({
        rangeDate: [date],
        hover: undefined
      });
      return;
    }

    this.setState((0, _immer.default)(function (draft) {
      var method = _utils.default.compareAsc(draft.rangeDate[0], date) > 0 ? 'unshift' : 'push';
      draft.rangeDate[method](date);
      draft.rangeDate.map(_this2.fillTime);
      draft.hover = undefined;
    }), function () {
      _this2.props.onChange(_this2.state.rangeDate, true, type === 'date');
    });
  };

  _proto.fillTime = function fillTime(date, index) {
    var _this$props2 = this.props,
        defaultTime = _this$props2.defaultTime,
        format = _this$props2.format,
        value = _this$props2.value;
    return _utils.default.formatDateWithDefaultTime(date, value[index], defaultTime[index], format);
  };

  _proto.handleDisabled = function handleDisabled(type, date) {
    var disabled = this.props.disabled;
    var rangeDate = this.state.rangeDate;

    if (disabled) {
      return disabled.apply(void 0, [date, type].concat(rangeDate));
    }

    return false;
  };

  _proto.render = function render() {
    var _this$props3 = this.props,
        current = _this$props3.current,
        value = _this$props3.value,
        range = _this$props3.range,
        children = _this$props3.children,
        props = _objectWithoutPropertiesLoose(_this$props3, ["current", "value", "range", "children"]);

    var rangeDate = [].concat(this.state.rangeDate);
    var rangeTemp;

    if (rangeDate.length === 1) {
      // eslint-disable-next-line
      rangeTemp = rangeDate[0];
      var method = _utils.default.compareAsc(rangeDate[0], this.state.hover) > 0 ? 'unshift' : 'push';
      rangeDate[method](this.state.hover);
    }

    return _react.default.createElement("div", {
      className: (0, _styles.datepickerClass)('range-picker')
    }, children, _react.default.createElement(_Picker.default, _extends({}, props, {
      pos: "start",
      disabled: this.handleDisabledStart,
      index: 0,
      max: rangeDate[1],
      current: current[0],
      range: typeof range === 'number' ? range : undefined,
      rangeDate: rangeDate,
      rangeTemp: rangeTemp,
      onChange: this.handleFirstChange,
      onDayHover: this.handleDayHover,
      ref: this.bindFirstPicker,
      value: _utils.default.toDateWithFormat(value[0], props.format),
      showTimePicker: value.length === 2
    })), _react.default.createElement(_Picker.default, _extends({}, props, {
      disabled: this.handleDisabledEnd,
      index: 1,
      min: rangeDate[0],
      current: current[1],
      range: typeof range === 'number' ? range : undefined,
      rangeDate: rangeDate,
      rangeTemp: rangeTemp,
      onChange: this.handleSecondChange,
      onDayHover: this.handleDayHover,
      ref: this.bindSecondPicker,
      value: _utils.default.toDateWithFormat(value[1], props.format),
      showTimePicker: value.length === 2
    })));
  };

  return Range;
}(_component.PureComponent);

Range.propTypes = {
  current: _propTypes.default.array,
  disabled: _propTypes.default.func,
  children: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.object]),
  format: _propTypes.default.string,
  onChange: _propTypes.default.func.isRequired,
  range: _propTypes.default.oneOfType([_propTypes.default.bool, _propTypes.default.number]),
  value: _propTypes.default.array,
  type: _propTypes.default.string.isRequired,
  defaultTime: _propTypes.default.array
};
Range.defaultProps = {
  value: []
};
var _default = Range;
exports.default = _default;